export const normalizeCapabilitiesTileData = ({ slotData, componentData, mediaCollectionIndex, componentId }) => {
  // If componentData exists, prioritize it over slotData
  if (componentData) {
    return {
      entryId: componentId,
      normalizedData: [componentData.component || null]
    };
  }

  // Otherwise, transform slotData to expected structure (fusion pattern)
  if (slotData) {
    const slot = slotData.slot;
    const mediaCollections = slot.mediaCollections || [];
    const fallbackMediaCollection = mediaCollections[0] || null;
    const mediaCollection = mediaCollections[mediaCollectionIndex] || fallbackMediaCollection;

    const normalizedData = mediaCollection?.media?.map((media, mediaIndex) => {
      return {
        id: mediaIndex,
        entryId: media?.entryId || '',
        title: media?.title || '',
        description: media?.description || '',
        cta: media?.callToAction || '',
        link: media?.sourceDesktop?.[0]?.hyperlink || media?.sourceMobile?.[0]?.hyperlink,
        previewImage: {
          damDownloadedContent: {
            url: media?.sourceDesktop?.[0]?.uri || media?.sourceMobile?.[0]?.uri || '',
          }
        }
      };

    });

    return {
      entryId: mediaCollection.entryId,
      normalizedData
    };
  }

  // Return null if neither componentData nor slotData exist
  return {
    normalizedData: null,
    entryId: null
  };
};
